import React, { useState, useEffect,useContext } from 'react'
import { Button, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Avatar, CardMedia, ButtonGroup, Dialog, Slide, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddService from './AddService';
import { collection, query, orderBy, onSnapshot, deleteDoc, doc, writeBatch, where, getDocs } from "firebase/firestore"
import { app, database, storage } from '../../../firebaseConfig'
import EditService from './EditService';
import { DataGrid, GridActionsCellItem, GridToolbar, frFR } from '@mui/x-data-grid';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import dateFormat, { masks } from "dateformat";
import { deleteObject, ref } from 'firebase/storage';
import LinearProgress from '@mui/material/LinearProgress'
import { AuthContext } from '../../../AuthProvider';
import AccessDinied from '../../../components/AccessDinied';
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});
function Service() {
    const {user}=useContext(AuthContext)
    const [services, setServices] = useState([])
    const [service, setService] = useState({})
    const [showAddModal, setShowAddModal] = useState(false)
    const [showEditModal, setShowEditModal] = useState(false)
    const [confirmDelete, setConfirmDelete] = useState(false)
    const [loadingData, setLoadingData] = useState(true)
    const handleCloseConfirm = () => {
        setConfirmDelete(false);
    };
    const columns = [
        {
            field: 'image_service',
            headerName: 'Photo',
            minWidth: 50,
            sortable: false,
            filterable: false,
            disableExport: true,
            renderCell: (params) => {
                return (
                    <CardMedia
                        component='img'
                        height="40"
                        image={params.value}
                        alt={params.row.nom_service}
                        
                    />
                )
            }
        },
        { field: 'nom_service', headerName: 'Nom', width: 150, },
        { field: 'partie', headerName: 'Partie', width: 100 },
        { field: 'description_service', headerName: 'Description', width: 450 },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Actions',
            minWidth: 50,
            cellClassName: 'actions',
            getActions: (params) => {
                return [
                    <GridActionsCellItem icon={<EditIcon />}
                        label="Edit"
                        sx={{
                            color: 'primary.main',
                        }}
                        onClick={() => {
                            setService(params.row)
                            setShowEditModal(true)
                        }} />,
                    <GridActionsCellItem icon={<DeleteIcon color='error' />}
                        label="Supprimer"
                        sx={{
                            color: 'primary.main',
                        }}
                        onClick={() => {
                            // handleDelete(params.id)
                            setConfirmDelete(true)
                            setService(params.row)
                        }} />
                ]
            }
        }
    ]
    useEffect(() => {
        setLoadingData(true)
        const q = query(collection(database, 'service'), orderBy('nom_service', 'asc'))
        onSnapshot(q, (querySnapshot) => {
            setServices(querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            })))
        })
        setLoadingData(false)
    }, [])
    const handleDelete = async (id) => {
        const sericeDocRef = doc(database, 'service', id)
        try {
            await deleteServiceChu(id)
            await deleteReservation(id)
            await deleteDoc(sericeDocRef)
            const imageRef = ref(storage, service.image_service)
            await deleteObject(imageRef)
            
        } catch (err) {
            alert(err)
        }
    }
    const deleteServiceChu = async (idService) => {
        const q = query(collection(database, 'service_chu'),where('service_id','==',idService))
        const batch = writeBatch(database);
        const service_chu_refs = await getDocs(q);
        service_chu_refs.forEach((docChu) => {
            batch.delete(doc(database, "service_chu", docChu.id))
        })
        await batch.commit();
    }
    const deleteReservation = async (idService) => {
        const q = query(collection(database, 'reservation'),where('service_id','==',idService))
        const batch = writeBatch(database);
        const service_chu_refs = await getDocs(q);
        service_chu_refs.forEach((docChu) => {
            batch.delete(doc(database, "reservation", docChu.id))
        })
        await batch.commit();
    }
    if(user.type !='Admin'){
        return <AccessDinied/>
    }
    return (
        <div style={{ width: '100%', flexGrow: 1, overflow: 'hidden' }}>
            <Button variant="contained" size='small' onClick={() => { setShowAddModal(true) }} startIcon={<AddCircleOutlineIcon />}>
                Ajouter
            </Button>
            <div style={{ width: '100%', height: 450 }}>
                <DataGrid
                    rowSelection={false}
                    columns={columns}
                    rows={services}
                    rowHeight={70}
                    sx={{ width: '100%', marginTop: 2 }}
                    loading={loadingData}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 10,
                            },
                        },
                    }}
                    pageSizeOptions={[10,25,100]}
                    localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
                    slots={{
                        toolbar: GridToolbar,
                        loadingOverlay: LinearProgress,
                    }}
                    slotProps={{
                        toolbar: {
                            printOptions: { disableToolbarButton: true },
                            csvOptions: {
                                fileName: 'service_csv_' + dateFormat(new Date(), 'yyyymmddHHMMss'),
                                delimiter: ',',
                                utf8WithBom: true,
                            }
                        }
                    }}
                />
            </div>
            {showAddModal &&
                <AddService onClose={() => setShowAddModal(false)} open={showAddModal} list={services} />
            }
            {showEditModal &&
                <EditService onClose={() => setShowEditModal(false)} open={showEditModal} data={service} list={services} />
            }
            <Dialog
                open={confirmDelete}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleCloseConfirm}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>Suppression!</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        Cette action pourra entrainer la perte d'autres données relatives à celle-ci.<br />
                        Cliquez sur confirmer, si vous voulez continuer.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseConfirm}>Annuler</Button>
                    <Button
                        variant='contained'
                        color='error'
                        onClick={() => {
                            handleDelete(service.id)
                            setConfirmDelete(false)
                        }}>Confirmer</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default Service